// extracted by mini-css-extract-plugin
export default {"content":"modal-overlay_content__YyBL8"};